import axios from 'axios';
import { API_URL } from './api';

export const exteriorsService = {
    getAll () {
        console.log('exteriorsService: getAll');

        return axios
            .get(`${API_URL}/exteriors`)
            .then((response) => {
                if (response.data.list)
                {
                    return response.data.list;
                }

                return response;
            });
    },
};

export default exteriorsService;
